import type { ApiBusiness } from '../services/api';
import type { MapPin } from './nearbyMapViewport';

function num(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

export function fixedCoordinateFromBusiness(business: ApiBusiness): { lat: number; lng: number } | null {
  const row = business.addresses?.[0];
  if (!row) return null;
  const lat = num(row.latitude);
  const lng = num(row.longitude);
  if (lat == null || lng == null) return null;
  if (Math.abs(lat) <= 0.0001 && Math.abs(lng) <= 0.0001) return null;
  return { lat, lng };
}

export function fixedPinsFromBusinesses(businesses: ApiBusiness[]): MapPin[] {
  const pins: MapPin[] = [];
  for (const business of businesses) {
    const placeType = business.place_type_id ?? business.placetype?.id;
    if (placeType !== 1) continue;
    const coord = fixedCoordinateFromBusiness(business);
    if (!coord) continue;
    const name = (business.name ?? '').trim();
    pins.push({
      name: name || 'Maps',
      lat: coord.lat,
      lng: coord.lng,
    });
  }
  return pins;
}
